/* eslint-disable @typescript-eslint/no-unused-vars */
import { ImageList, ImageListItem, Skeleton } from '@mui/material'
import { useListContext } from 'react-admin'
import { times } from '../../utils/times'
import { LoadingImageGridProps } from './type'

const sanitizeRestProps = (props): LoadingImageGridProps => {
  const { isRowSelectable, empty, bulkActionButtons, rowClick, hasBulkActions, ...rest } = props
  return rest
}

export const LoadingImageGrid: React.FC<LoadingImageGridProps> = (props) => {
  const { perPage } = useListContext()
  const { sx = {}, ...rest } = sanitizeRestProps(props)
  return (
    <ImageList sx={{ m: 0, ...sx }} {...rest}>
      {times(perPage, (key) => (
        <ImageListItem key={key}>
          <Skeleton variant='rectangular' width='100%' height='100%' />
        </ImageListItem>
      ))}
    </ImageList>
  )
}
